import { useAuthStore } from '@/stores/authStore';

// VITE_WS_URL defaults to /api/v1/ws which is the backend WebSocket endpoint.
// In dev mode, Vite proxy handles forwarding. In production, Traefik routes it.
const WS_BASE_URL: string = import.meta.env['VITE_WS_URL'] ||
  `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}/api/v1/ws`;

/** URL del WebSocket del backend (con el token actual). Compartida por el detalle y la sync global. */
export function buildDeployWsUrl(): string {
  const token = useAuthStore.getState().token;
  let wsUrl = WS_BASE_URL;
  if (wsUrl.startsWith('/')) {
    // Relative path — build full WebSocket URL from current location
    const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    wsUrl = `${proto}//${window.location.host}${wsUrl}`;
  } else if (wsUrl.startsWith('http')) {
    // Convert http(s) to ws(s)
    wsUrl = wsUrl.replace(/^http/, 'ws');
  }
  return `${wsUrl}${token ? `?token=${token}` : ''}`;
}
